var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5.5 5.649.5 12 5.649 23.5 12 23.5z",
    stroke: "#FF7534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.65 9.189a2.46 2.46 0 001.033-1.371c-.454.284-.956.49-1.492.601a2.288 2.288 0 00-1.715-.783c-1.298 0-2.35 1.11-2.35 2.479 0 .194.02.383.06.564-1.952-.103-3.683-1.09-4.843-2.59a2.577 2.577 0 00-.318 1.247c0 .86.415 1.618 1.045 2.063a2.266 2.266 0 01-1.065-.31v.031c0 1.201.81 2.203 1.886 2.43a2.208 2.208 0 01-1.062.043c.3.985 1.167 1.702 2.196 1.722a4.562 4.562 0 01-3.48 1.026 6.407 6.407 0 003.603 1.113c4.323 0 6.686-3.776 6.686-7.052 0-.107-.002-.214-.007-.32.46-.35.859-.786 1.173-1.283-.422.197-.875.33-1.35.39z",
    fill: "#FF7534"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.42d87b7ae69121131b8db88bd979a844.svg";
export { ForwardRef as ReactComponent };